/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AllObjectAssignmentsResponse,
  ApiAssignmentExportCsvRequest,
  ApiAssignmentRequest,
  ApiAssignmentResponse,
  ApiBudgetMatchesResponse,
  ApiBudgetPeriodPrepareRequest,
  ApiBudgetRecommendationsResponse,
  ApiPagedAssignmentRequest,
  ApiPagedAssignmentResponse,
  ApiPagedBudgetRequest,
  ApiUpdateBudgetGroupRequest,
  ApiUpdateBudgetPeriodRequest,
  ApiUpdateBudgetResponse,
  BudgetGroupResponse,
  BudgetPeriodResponse,
  BudgetWithSpendersAndGroupInfoAndSubBudgets,
  GetAllBudgetsAssignedToParams,
  GetAllRecommendedBudgetsParams,
  GetPurchaseRequestBudgetsMatchWithSpendBudgetsParams,
  GetPurchaseRequestBudgetsMatchWithSpendBudgetsPayload,
  PaginatedResponseBudgetWithSpendersBudgetPagedMeta,
  UnassignFromBudgetV2Params,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiBudgetController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-budget-controller
   * @name UpdateBudgetGroup
   * @request PUT:/api/v1/budgets
   */
  updateBudgetGroup = (data: ApiUpdateBudgetGroupRequest, params: RequestParams = {}) =>
    this.http.request<BudgetGroupResponse, any>({
      path: `/v1/budgets`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBudgetGroupPath = '/v1/budgets'
  static updateBudgetGroupMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name FindBudgetByIdAndOrganisationId
   * @request GET:/api/v1/budgets/{budgetId}
   */
  findBudgetByIdAndOrganisationId = (budgetId: string, params: RequestParams = {}) =>
    this.http.request<BudgetWithSpendersAndGroupInfoAndSubBudgets, any>({
      path: `/v1/budgets/${budgetId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findBudgetByIdAndOrganisationIdPath = '/v1/budgets/${budgetId}'
  static findBudgetByIdAndOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name UpdateBudgetPeriod
   * @request PUT:/api/v1/budgets/{budgetId}
   */
  updateBudgetPeriod = (
    budgetId: string,
    data: ApiUpdateBudgetPeriodRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiUpdateBudgetResponse, any>({
      path: `/v1/budgets/${budgetId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBudgetPeriodPath = '/v1/budgets/${budgetId}'
  static updateBudgetPeriodMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name DeleteBudgetByIdAndOrganisationId
   * @request DELETE:/api/v1/budgets/{budgetId}
   */
  deleteBudgetByIdAndOrganisationId = (budgetId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/budgets/${budgetId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteBudgetByIdAndOrganisationIdPath = '/v1/budgets/${budgetId}'
  static deleteBudgetByIdAndOrganisationIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name AssignToBudget
   * @request POST:/api/v1/budgets/{budgetId}/assignments
   */
  assignToBudget = (budgetId: string, data: ApiAssignmentRequest, params: RequestParams = {}) =>
    this.http.request<ApiAssignmentResponse, any>({
      path: `/v1/budgets/${budgetId}/assignments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static assignToBudgetPath = '/v1/budgets/${budgetId}/assignments'
  static assignToBudgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name UnassignFromBudgetV2
   * @request DELETE:/api/v1/budgets/{budgetId}/assignments
   */
  unassignFromBudgetV2 = (
    { budgetId, ...query }: UnassignFromBudgetV2Params,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/budgets/${budgetId}/assignments`,
      method: 'DELETE',
      query: query,
      ...params,
    })

  static unassignFromBudgetV2Path = '/v1/budgets/${budgetId}/assignments'
  static unassignFromBudgetV2Method = 'DELETE'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name PagedBudgetAssignments
   * @request POST:/api/v1/budgets/{budgetId}/assignments/paged
   */
  pagedBudgetAssignments = (
    budgetId: string,
    data: ApiPagedAssignmentRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiPagedAssignmentResponse, any>({
      path: `/v1/budgets/${budgetId}/assignments/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static pagedBudgetAssignmentsPath = '/v1/budgets/${budgetId}/assignments/paged'
  static pagedBudgetAssignmentsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name ExportAssignmentsCsv
   * @request POST:/api/v1/budgets/{budgetId}/assignments/export/csv
   */
  exportAssignmentsCsv = (
    budgetId: string,
    data: ApiAssignmentExportCsvRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/budgets/${budgetId}/assignments/export/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static exportAssignmentsCsvPath = '/v1/budgets/${budgetId}/assignments/export/csv'
  static exportAssignmentsCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name PrepareBudgetPeriods
   * @request POST:/api/v1/budgets/prepare-periods
   */
  prepareBudgetPeriods = (data: ApiBudgetPeriodPrepareRequest, params: RequestParams = {}) =>
    this.http.request<BudgetPeriodResponse, any>({
      path: `/v1/budgets/prepare-periods`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static prepareBudgetPeriodsPath = '/v1/budgets/prepare-periods'
  static prepareBudgetPeriodsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name PagedBudget
   * @request POST:/api/v1/budgets/paged
   */
  pagedBudget = (data: ApiPagedBudgetRequest, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseBudgetWithSpendersBudgetPagedMeta, any>({
      path: `/v1/budgets/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static pagedBudgetPath = '/v1/budgets/paged'
  static pagedBudgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetPurchaseRequestBudgetsMatchWithSpendBudgets
   * @request POST:/api/v1/budgets/matches
   */
  getPurchaseRequestBudgetsMatchWithSpendBudgets = (
    query: GetPurchaseRequestBudgetsMatchWithSpendBudgetsParams,
    data: GetPurchaseRequestBudgetsMatchWithSpendBudgetsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiBudgetMatchesResponse, any>({
      path: `/v1/budgets/matches`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPurchaseRequestBudgetsMatchWithSpendBudgetsPath = '/v1/budgets/matches'
  static getPurchaseRequestBudgetsMatchWithSpendBudgetsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name FindBudgetGroupByIdAndOrganisationId
   * @request GET:/api/v1/budgets/{budgetId}/group
   */
  findBudgetGroupByIdAndOrganisationId = (budgetId: string, params: RequestParams = {}) =>
    this.http.request<BudgetGroupResponse, any>({
      path: `/v1/budgets/${budgetId}/group`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findBudgetGroupByIdAndOrganisationIdPath = '/v1/budgets/${budgetId}/group'
  static findBudgetGroupByIdAndOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetAllRecommendedBudgets
   * @request GET:/api/v1/budgets/recommended-to
   */
  getAllRecommendedBudgets = (query: GetAllRecommendedBudgetsParams, params: RequestParams = {}) =>
    this.http.request<ApiBudgetRecommendationsResponse, any>({
      path: `/v1/budgets/recommended-to`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllRecommendedBudgetsPath = '/v1/budgets/recommended-to'
  static getAllRecommendedBudgetsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetAllBudgetsAssignedTo
   * @request GET:/api/v1/budgets/assignedTo
   */
  getAllBudgetsAssignedTo = (query: GetAllBudgetsAssignedToParams, params: RequestParams = {}) =>
    this.http.request<AllObjectAssignmentsResponse, any>({
      path: `/v1/budgets/assignedTo`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllBudgetsAssignedToPath = '/v1/budgets/assignedTo'
  static getAllBudgetsAssignedToMethod = 'GET'
}
